/** Every telemetry sink redacts URLs through `redactUrlSecrets`, driven by these lists alone. */

export const REDACTED_VALUE = 'REDACTED'

/** URL-valued params (`/login?next=…`) are redacted recursively and need no entry. */
export const SECRET_QUERY_PARAMS = [
  'token',
  'reset_token',
  'invitation_token',
  'verification_token',
  'data_access_token',
  'invitation_code',
  'opt_out_token',
  'sign_in_token',
  'code',
  'oauth_state_id',
  'hmac',
  'url',
] as const

export const SECRET_PATH_PATTERNS = [/(\/public-invoice\/)[^/?#]+/] as const
